import { Component, Input, OnChanges } from '@angular/core';

import { FootnoteService } from './footnote.service';

@Component({
  selector: 'hcf-footnotes',
  templateUrl: './footnotes.component.html',
  styleUrls: ['./footnotes.component.scss'],
  standalone: false,
})
export class FootnotesComponent implements OnChanges {
  @Input() footnotes: string[];

  constructor(private _footnotesService: FootnoteService) {}

  ngOnChanges() {
    this.footnotes = this._footnotesService.getFootnotes();
  }
}
